import { FaCopyright } from "react-icons/fa";
import { Link } from "react-router-dom";
import { footerLinks, socialMedia } from "../../app/constants";

const Footer = () => {
  return (
    <footer className=" bg-black padding-x padding-t pb-8">
      <div className="flex justify-between items-start gap-20 flex-wrap max-lg:flex-col">
        <div className="flex flex-col items-start">
          <Link to="/" className="flex-shrink-0 flex flex-row items-center ">
            <img
              className="m-0 h-[29px] grayscale"
              src="/thehaven-circle.png"
              alt="The Have Store logo"
            />
            <span className=" font-poiret text-3xl pl-2 font-bold text-white hover:text-slate-gray transition-all ease-in-out">
              The
              <span className="text-coral-red hover:text-inherit">Haven</span>
              Store
            </span>
          </Link>
          <p className="mt-6 text-base leading-7 font-montserrat text-white-400 sm:max-w-sm">
            Get shoes ready for the new term at your nearest Nike store. Find
            Your perfect Size In Store. Get Rewards
          </p>
          <div className="flex items-center gap-5 mt-8">
            {socialMedia.map((icon) => (
              <Link
                to={icon.link}
                target="_blank"
                className="flex justify-center items-center w-12 h-12 bg-white rounded-full text-2xl"
                key={icon.alt}
              >
                {icon.src}
              </Link>
            ))}
          </div>
        </div>

        <div className="flex flex-1 justify-around  lg:gap-10 gap-20 flex-wrap">
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-montserrat text-2xl leading-normal font-medium mb-6 text-white">
                {section.title}
              </h4>
              <ul>
                {section.links.map((link) => (
                  <li
                    className="mt-3 font-montserrat text-base leading-normal text-white-400 hover:text-slate-gray"
                    key={link.name}
                  >
                    <Link to={link.link}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-between text-white-400 mt-24 max-sm:flex-col max-sm:items-center">
        <div className="flex flex-1 justify-start items-center gap-2 font-montserrat cursor-pointer">
          <FaCopyright className="text-xl" />

          <p>Copyright. All rights reserved.</p>
        </div>
        <p className="font-montserrat cursor-pointer">Terms & Conditions</p>
      </div>
    </footer>
  );
};

export default Footer;
